const registeredLanguages = new Set<string>();

/**
 * Creates a register-once function for a custom Monaco language.
 * Ensures the language definition is only registered once across all editor instances.
 */
export const createLanguageRegistrar = (
  registration: { id: string; extensions?: string[]; aliases?: string[] },
  tokensDef: Record<string, unknown>,
): ((monacoGlobal: typeof monaco) => void) => {
  return (monacoGlobal: typeof monaco): void => {
    if (registeredLanguages.has(registration.id)) return;
    monacoGlobal.languages.register(registration);
    monacoGlobal.languages.setMonarchTokensProvider(registration.id, tokensDef);
    registeredLanguages.add(registration.id);
  };
};
